export default "__VITE_ASSET__C4MdPW40__"